import React from 'react';
import useDebounceWithMemoizedCallback from 'Hooks/useDebounceWithMemoizedCallback';

// This is not in the context so that we don't re-render the context on every key stroke
export default function useInstitutionSearch(handleFilterInstitutions, startingInstitutionName = '') {
  const [institutionName, setInstitutionName] = React.useState(startingInstitutionName);

  const debouncedFilterInstitutions = useDebounceWithMemoizedCallback(handleFilterInstitutions, 250);

  const handleChange = (searchTerm) => {
    setInstitutionName(searchTerm);
    debouncedFilterInstitutions(searchTerm);
  };

  return {
    institutionName,
    handleChange,
  };
}
